module.exports = __webpack_public_path__ + "static/media/eyes.3608c468.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/eyes.png
// module id = 47
// module chunks = 0